import React, { Component, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import classnames from "classnames";
import searchIcon from "../images/search_icon.svg";
import selectIconAlt from "../images/select_icon_alt.svg";
import selectIcon from "../images/select_icon.svg";
import cancelX from "../images/cancelx.svg";
import faceIcon1 from "../images/okkiFace1.svg";
import faceIcon2 from "../images/okkiFace2.svg";
import faceIcon3 from "../images/okkiFace3.svg";
import faceIcon4 from "../images/okkiFace4.svg";
import faceIcon5 from "../images/okkiFace5.svg";
import faceIcon6 from "../images/okkiFace6.svg";
import faceIcon7 from "../images/okkiFace7.svg";
import Select, { components } from "react-select";
import { logOut, route, getNegocios, loggedIn, SearchResults, bucket_route, getCurrentNegocio, user_token, getPublicEstados, SearchTyping } from "./API Functions";
import NewSettings from "./NewSettings";
import itemProfile from "../images/itemProfile.svg";
import Modal from "react-modal";
import Settings from "./Settings";
import SidebarSettings from "./SidebarSettings";
import WelcomeSettings from "./WelcomeSettings";
import Settings2 from "./Settings-2";
import Settings4 from "./Settings-4";
import Settings5 from "./Settings-5";
import Settings3 from "./Settings-3";
import profileThumb from "../images/profilePlaceholder.svg";
import Fade from "react-reveal/Fade";
import MediaQuery from 'react-responsive'
import ProductoModal from "./ProductoModal";
import SettingsNegocio from "./Settings-Negocio";
import SettingsReady from "./SettingsReady";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: 900,
    maxHeight: 700,
    height: "90%",
    padding: 40,
    border: "none",
    borderRadius: 12,
  },
};

const customStylesResponsive = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: 900,
    height: "100%",
    padding: 20,
    border: "none",
    paddingTop: 0
  },
};

const options = [
  { value: "monterrey", label: "Monterrey" },
  { value: "guadalajara", label: "Guadalajara" },
  { value: "cdmx", label: "CDMX" },
];

const okkiFaces = [
  faceIcon1,
  faceIcon2,
  faceIcon3,
  faceIcon4,
  faceIcon5,
  faceIcon6,
  faceIcon7,
];

function openNav() {
  const navigationWindow = document.getElementById("myNav");
  navigationWindow.style.width = "580px";
  const navbarOverlay = document.getElementById("navbarOverlay");
  navbarOverlay.style.opacity = 1;
  navbarOverlay.style.width = "100%";
  navbarOverlay.style.visibility = "visible";
  document.body.style.overflow = "hidden"
  const menuContainer1 = document.getElementById("menuContainer1");
  if (menuContainer1) {
    menuContainer1.style.display = "block";
  }
  const menuContainer2 = document.getElementById("menuContainer2");
  if (menuContainer2) {
    menuContainer2.style.display = "block";
  }
}

function closeNav() {
  const navigationWindow = document.getElementById("myNav");
  navigationWindow.style.width = "0%";
  const navbarOverlay = document.getElementById("navbarOverlay");
  navbarOverlay.style.opacity = 0;
  navbarOverlay.style.visibility = "hidden";
  document.body.style.overflow = "auto"
  const menuContainer1 = document.getElementById("menuContainer1");
  if (menuContainer1) {
    menuContainer1.style.display = "none";
  }
  const menuContainer2 = document.getElementById("menuContainer2");
  if (menuContainer2) {
    menuContainer2.style.display = "none";
  }
}

const DropdownIndicator = (
  props: ElementConfig<typeof components.DropdownIndicator>
) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 8L10 12L14 8"
          stroke="#081027"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </components.DropdownIndicator>
  );
};



export default class Navbar extends React.Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.state = {
      prevScrollpos: typeof window !== "undefined" && window.pageYOffset,
      visible: true,
      activeLogo: false,
      visibleLogo: false,
      hoveredBuy: false,
      hoveredEat: false,
      hoveredHire: false,
      isOpen: false,
      negocio: localStorage.getItem('negocio') ? JSON.parse(localStorage.getItem('negocio')) : [],
      settings_section: 0,
      logged_in: false,
      keywords: "",
      estado : [],
      estados : [],
      search_negocios : [],
      search_categorias : []
    };
  }
  state = {
    activeMenu: true,
    isFocused: false,
    isFocusedMobile: false,
    modalIsOpen: false,
    modalWelcomeIsOpen: false,
    Loading: false,
    activeMobileSearch: false,
    navbarOpen: false
  };

  openModal = () => {
    closeNav();
    this.setState({
      modalIsOpen: true,
    })
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      settings_section: 0,
    })
  }

  openWelcomeModal = () => {
    closeNav();
    this.setState({
      modalWelcomeIsOpen: true
    })
  }
  closeWelcomeModal = () => {
    this.setState({
      modalWelcomeIsOpen: false,
      settings_section: 0
    })
  }

  onMouseEnterBuy = (e) => {
    this.setState({ hoveredBuy: true });
  };
  onMouseEnterEat = (e) => {
    this.setState({ hoveredEat: true });
  };
  onMouseEnterHire = (e) => {
    this.setState({ hoveredHire: true });
  };

  onMouseLeaveBuy = (e) => {
    this.setState({ hoveredBuy: false });
  };
  onMouseLeaveEat = (e) => {
    this.setState({ hoveredEat: false });
  };
  onMouseLeaveHire = (e) => {
    this.setState({ hoveredHire: false });
  };

  onFocusChange = () => {
    this.setState({ isFocused: !this.state.isFocused });


  };

  onFocusChangeMobile = () => {
    this.setState({ isFocusedMobile: !this.state.isFocusedMobile });
  };

  toggleMenu = () => {
    this.setState({
      activeMenu: !this.state.activeMenu,
    });
  };
  escFunction(event) {
    if (event.keyCode === 27) {
      const navigationWindow = document.getElementById("myNav");
      navigationWindow.style.width = "0%";
      const navbarOverlay = document.getElementById("navbarOverlay");
      navbarOverlay.style.opacity = 0;
      navbarOverlay.style.visibility = "hidden";
      document.body.style.overflow = "auto"
      const menuContainer1 = document.getElementById("menuContainer1");
      if (menuContainer1) {
        menuContainer1.style.display = "none";
      }
      const menuContainer2 = document.getElementById("menuContainer2");
      if (menuContainer2) {
        menuContainer2.style.display = "none";
      }
    }
  }

  
  componentDidMount() {
    if (user_token && !this.state.negocio.id) {
      getCurrentNegocio().then(res => {
        if (res) {
          localStorage.setItem('negocio', JSON.stringify(res))
          this.setState({
            negocio: res
          })
        }else{
          window.location.replace('/login');
        }
      })
    }
    if (typeof window === "undefined") {
      global.window = {};
    }
    window.addEventListener("scroll", this.handleScroll);

    document.addEventListener("keydown", this.escFunction, false);

    document.addEventListener("mousedown", this.handleClickOutside);

    this.changeImage();


    if (this.state.negocio.nuevo) {
      this.setState({
        modalWelcomeIsOpen: true,
        modalIsOpen: true,
      })
    }

    getPublicEstados().then(res=>{
      if(res){
        var states = [];
        const current_state = cookies.get('state');
        const emptyoption = {
          value : 0,
          label : "Ver Todo"
        }
        states.push(emptyoption)
        res.map(estado =>{
          estado = {
            ...estado,
            value : estado.id,
            label : estado.name
          }
          if(estado.name == current_state){
            this.setState({
              estado : estado
            })
          }
          if(estado.negocios > 0){
            states.push(estado)
          }
        })
        this.setState({
          estados : states
        })
      }
    })

    //console.log(localStorage.getItem('negocio'))
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("keydown", this.escFunction, false);
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleScroll = () => {
    const { prevScrollpos } = this.state;

    const currentScrollPos = window.pageYOffset;
    const currentScrollPosLogo = window.pageYOffset >= 100;
    const visible = prevScrollpos > currentScrollPos || "100" > currentScrollPos;
    const visibleLogo =
      prevScrollpos > currentScrollPos || "400" > currentScrollPos;

    this.setState({
      prevScrollpos: currentScrollPos,
      visible,
    });
    this.setState({
      activeLogo: currentScrollPosLogo,
      visibleLogo,
    });
  };


  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      const navigationWindow = document.getElementById("myNav");
      navigationWindow.style.width = "0%";
      const navbarOverlay = document.getElementById("navbarOverlay");
      navbarOverlay.style.opacity = 0;
      navbarOverlay.style.visibility = "hidden";
      document.body.style.overflow = "auto"
      const menuContainer1 = document.getElementById("menuContainer1");
      if (menuContainer1) {
        menuContainer1.style.display = "none";
      }
      const menuContainer2 = document.getElementById("menuContainer2");
      if (menuContainer2) {
        menuContainer2.style.display = "none";
      }
    }
  }

  changeImage = () => {
    const randomNumber = Math.floor(Math.random() * okkiFaces.length);
    this.setState({
      currentImageIndex: randomNumber,
    });
  };

  handleSubmit = () => {

  }



  Search = keywords => {
    const data = {
      keywords: keywords
    }
    window.location.replace(`/search/${data.keywords}`)
  }

  clearSearch = () => {
    document.getElementById("searchInput").value = "";
  }

  clearSearchMobile = () => {
    document.getElementById("searchInputMobile").value = "";
  }

   setStateOnCookies = (data) => {
    var fifteen_days = new Date();
    var today = new Date();
    fifteen_days.setDate(today.getDate() + 15);
    cookies.set('state', data.label, {
      path: '/',
      expires: fifteen_days
    });
    window.location.reload();
  }

  handleSearch = (e) => {
    const data = {
      keywords : e.target.value
    }
    SearchTyping(data).then(res=>{
      if(res){
        this.setState({
          search_negocios : res.negocios,
          search_categorias : res.categorias
        })
      }
    })
    this.setState({ 
      keywords: e.target.value 
    })
  }

  render() {
    const { hoveredEat } = this.state;
    const { hoveredBuy } = this.state;
    const { hoveredHire } = this.state;
    const styleBuy = hoveredBuy ? { backgroundColor: "#A1D053" } : {};
    const styleEat = hoveredEat ? { backgroundColor: "#FFA114" } : {};
    const styleHire = hoveredHire ? { backgroundColor: "#3FC2FF" } : {};

    const handleKeyDown = (event) => {
      if (event.key === "Enter" && this.state.keywords !== "") {
        event.preventDefault();

        this.Search(event.target.value)
      }
    };

    const isFocused = this.state.isFocused;

    if (isFocused) {
      document.querySelector("body").style.overflow = 'hidden';

    } else {
      document.querySelector("body").style.overflow = 'auto';
    }

    const activeMobileSearch = this.state.activeMobileSearch;

    const settingsActive = this.state.settings_section;

    return (
      <>
        <Link to="/" className="okkiLogo">
          <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M45.5925 39.8231C46.9383 39.8904 48.0654 38.8137 48.0654 37.468V35.1633C48.0654 34.8773 48.4019 34.7259 48.6206 34.9109L53.9869 39.3016C54.4243 39.6549 54.9458 39.8399 55.4841 39.8399C56.1738 39.8399 56.8467 39.5371 57.3009 38.982C58.1252 37.9726 57.9738 36.4923 56.9645 35.668L52.4224 31.9502C52.086 31.681 52.086 31.1764 52.4224 30.9072L56.9645 27.1894C57.9738 26.3651 58.1252 24.8848 57.3009 23.8754C56.4766 22.8661 54.9963 22.7147 53.9869 23.539L48.6206 27.9296C48.4019 28.1147 48.0654 27.9465 48.0654 27.6773V25.4231C48.0654 24.1614 47.0897 23.068 45.828 23.0007C44.4822 22.9334 43.3551 24.01 43.3551 25.3558V37.4007C43.3551 38.6623 44.3308 39.7558 45.5925 39.8231ZM36.4075 42.1782C35.0617 42.1109 33.9346 43.1876 33.9346 44.5334V46.838C33.9346 47.124 33.5981 47.2754 33.3794 47.0904L28.0131 42.6997C27.5757 42.3465 27.0542 42.1614 26.5159 42.1614C25.8262 42.1614 25.1533 42.4642 24.6991 43.0194C23.8748 44.0287 24.0262 45.5091 25.0355 46.3334L29.5776 50.0511C29.914 50.3203 29.914 50.825 29.5776 51.0941L25.0355 54.8119C24.0262 55.6362 23.8748 57.1165 24.6991 58.1259C25.5234 59.1352 27.0037 59.2866 28.0131 58.4623L33.3794 54.0717C33.5981 53.8866 33.9346 54.0549 33.9346 54.324V56.5614C33.9346 57.8231 34.9103 58.9165 36.172 58.9838C37.5178 59.0511 38.6449 57.9745 38.6449 56.6287V44.5838C38.6449 43.339 37.6692 42.2455 36.4075 42.1782ZM31.4112 23.0007C26.7682 23.0007 23 26.7689 23 31.4119C23 36.0549 26.7682 39.8231 31.4112 39.8231C36.0542 39.8231 39.8224 36.0549 39.8224 31.4119C39.8224 26.7689 36.0542 23.0007 31.4112 23.0007ZM31.4112 35.1128C29.3757 35.1128 27.7103 33.4474 27.7103 31.4119C27.7103 29.3764 29.3757 27.7109 31.4112 27.7109C33.4467 27.7109 35.1121 29.3764 35.1121 31.4119C35.1121 33.4474 33.4467 35.1128 31.4112 35.1128ZM56.6449 48.2343H44.5327C43.2374 48.2343 42.1776 49.2941 42.1776 50.5894C42.1776 51.8848 43.2374 52.9446 44.5327 52.9446H56.6449C57.9402 52.9446 59 51.8848 59 50.5894C59 49.2941 57.9402 48.2343 56.6449 48.2343Z" fill="black" />
          </svg>
        </Link>
        <div
          id="navbarMain"
          className={classnames("navbarHideShow", {
            "navbarHideShow-hidden": !this.state.visible,
            "navbarHideShow-border": !this.state.activeLogo,
          })}
        >
          <div
            className={this.state.isFocused ? "navbarOverlay navbarOverlay-active" : 'navbarOverlay'}
          ></div>
          <div
            id="navbarOverlay"
            className="navbarOverlay navbarOverlay-active"
          ></div>
          <div
            className={this.state.isFocusedMobile ? 'navbarOverlay navbarOverlayMobile-active' : 'navbarOverlay'}
          ></div>
          <header
            className="navbar-home"
            className={
              this.state.isFocused ? "navbar-home navbar-homeFocused" : "navbar-home"
            }
          >
            <div
              className={
                this.state.isFocused
                  ? "navbar-home__section navbar-home__sectionReduced"
                  : "navbar-home__section"
              }
            >
              <div className="okkiSearchMobile" onClick={() => this.setState({ activeMobileSearch: !this.state.activeMobileSearch, isFocusedMobile: !this.state.isFocusedMobile })}>
                {this.state.activeMobileSearch ? <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="42" height="42" fill="white" />
                  <path d="M25.2426 16.7573L16.7573 25.2426" stroke="#C4C4C4" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M25.2427 25.2426L16.7574 16.7573" stroke="#C4C4C4" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                  : <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="42" height="42" fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 20.0002C14 16.6864 16.6864 14 20.0001 14C23.3139 14 26.0003 16.6864 26.0003 20.0002C26.0003 23.3139 23.3139 26.0003 20.0001 26.0003C16.6864 26.0003 14 23.3139 14 20.0002ZM20.0001 12C15.5818 12 12 15.5818 12 20.0002C12 24.4185 15.5818 28.0003 20.0001 28.0003C21.8489 28.0003 23.5512 27.3732 24.9059 26.3201L28.293 29.7072C28.6835 30.0977 29.3167 30.0977 29.7072 29.7072C30.0977 29.3167 30.0977 28.6835 29.7072 28.293L26.3201 24.9059C27.3732 23.5512 28.0003 21.8489 28.0003 20.0002C28.0003 15.5818 24.4185 12 20.0001 12Z" fill="#081027" />
                  </svg>
                }

              </div>
              <Link to="/" className="okkiLogoMobile">
                <div>
                  <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M45.5925 39.8231C46.9383 39.8904 48.0654 38.8137 48.0654 37.468V35.1633C48.0654 34.8773 48.4019 34.7259 48.6206 34.9109L53.9869 39.3016C54.4243 39.6549 54.9458 39.8399 55.4841 39.8399C56.1738 39.8399 56.8467 39.5371 57.3009 38.982C58.1252 37.9726 57.9738 36.4923 56.9645 35.668L52.4224 31.9502C52.086 31.681 52.086 31.1764 52.4224 30.9072L56.9645 27.1894C57.9738 26.3651 58.1252 24.8848 57.3009 23.8754C56.4766 22.8661 54.9963 22.7147 53.9869 23.539L48.6206 27.9296C48.4019 28.1147 48.0654 27.9465 48.0654 27.6773V25.4231C48.0654 24.1614 47.0897 23.068 45.828 23.0007C44.4822 22.9334 43.3551 24.01 43.3551 25.3558V37.4007C43.3551 38.6623 44.3308 39.7558 45.5925 39.8231ZM36.4075 42.1782C35.0617 42.1109 33.9346 43.1876 33.9346 44.5334V46.838C33.9346 47.124 33.5981 47.2754 33.3794 47.0904L28.0131 42.6997C27.5757 42.3465 27.0542 42.1614 26.5159 42.1614C25.8262 42.1614 25.1533 42.4642 24.6991 43.0194C23.8748 44.0287 24.0262 45.5091 25.0355 46.3334L29.5776 50.0511C29.914 50.3203 29.914 50.825 29.5776 51.0941L25.0355 54.8119C24.0262 55.6362 23.8748 57.1165 24.6991 58.1259C25.5234 59.1352 27.0037 59.2866 28.0131 58.4623L33.3794 54.0717C33.5981 53.8866 33.9346 54.0549 33.9346 54.324V56.5614C33.9346 57.8231 34.9103 58.9165 36.172 58.9838C37.5178 59.0511 38.6449 57.9745 38.6449 56.6287V44.5838C38.6449 43.339 37.6692 42.2455 36.4075 42.1782ZM31.4112 23.0007C26.7682 23.0007 23 26.7689 23 31.4119C23 36.0549 26.7682 39.8231 31.4112 39.8231C36.0542 39.8231 39.8224 36.0549 39.8224 31.4119C39.8224 26.7689 36.0542 23.0007 31.4112 23.0007ZM31.4112 35.1128C29.3757 35.1128 27.7103 33.4474 27.7103 31.4119C27.7103 29.3764 29.3757 27.7109 31.4112 27.7109C33.4467 27.7109 35.1121 29.3764 35.1121 31.4119C35.1121 33.4474 33.4467 35.1128 31.4112 35.1128ZM56.6449 48.2343H44.5327C43.2374 48.2343 42.1776 49.2941 42.1776 50.5894C42.1776 51.8848 43.2374 52.9446 44.5327 52.9446H56.6449C57.9402 52.9446 59 51.8848 59 50.5894C59 49.2941 57.9402 48.2343 56.6449 48.2343Z" fill="black" />
                  </svg>
                </div>
              </Link>
            </div>
            <div
              className="navbar-home__section navbar-home__section2"
              className={
                this.state.isFocused
                  ? "navbar-home__section navbar-home__sectionExp navbar-home__section2"
                  : "navbar-home__section navbar-home__section2"
              }
            >
              <span
                className={
                  this.state.isFocused
                    ? "navbar-home__search-icon navbar-home__search-iconHover"
                    : "navbar-home__search-icon"
                }
                onClick={this.clearSearch}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="20" height="20" fill="white" />
                  <path d="M9.125 15.25C12.5077 15.25 15.25 12.5077 15.25 9.125C15.25 5.74226 12.5077 3 9.125 3C5.74226 3 3 5.74226 3 9.125C3 12.5077 5.74226 15.25 9.125 15.25Z" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M17 17L13.5 13.5" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

              </span>
              <input
                type="search"
                placeholder="Buscar..."
                id="searchInput"
                onFocus={this.onFocusChange}
                onBlur={this.onFocusChange}
                onChange={(e)=>{this.handleSearch(e)}}
                onKeyDown={handleKeyDown}
                className="navbar-home__search"
                style={{ backgroundImage: `url(${cancelX})` }}
              />

              <div className="navbar-home__sectionDropdown"
                className={
                  this.state.isFocused && this.state.keywords
                    ? "navbar-home__sectionDropdown navbar-home__sectionDropdownActive"
                    : "navbar-home__sectionDropdown"
                }>
                {this.state.search_categorias.length > 0 ?
                <div className="navbar-home__sectionDropdown-searched">
                  <p className="navbar-home__sectionDropdown-title">Lo más buscado</p>
                  <ul>
                    {this.state.search_categorias.map((categoria,index)=>(
                        <li className="itemTag" onClick={()=>{this.Search(categoria.detalle)}} >{categoria.detalle}</li>
                      ))
                    }
                  </ul>
                </div>
                :
                null
                }
                { this.state.search_negocios.length > 0 ?
                <div className="navbar-home__sectionDropdown-new">
                  <p className="navbar-home__sectionDropdown-title">Negocios en Okki</p>
                  <ul>
                    {this.state.search_negocios.map((negocio,index)=>(
                      <li>
                      <a href={`/${negocio.dominio_okki}`}>
                      <div className="navbar-home__sectionDropdown-profile" >
                        <img className="homeGrid-item__icon" src={negocio.imagen_url ? `${bucket_route}${negocio.imagen_url}` : itemProfile} />
                        <p className="navbar-home__sectionDropdown-profileName">{negocio.nombre}</p>
                      </div>
                      </a>
                      <div>
                        <p className="itemTagAlt">$$$</p>
                      </div>
                    </li>
                    ))

                    }
                
                  </ul>
                </div>
                :
                null
                  }

                {/* <div className="navbar-home__sectionDropdown-suggest">
                <p className="navbar-home__sectionDropdown-title">Sugerido</p>
                <ul>
                  <li>
                    <p>Maestro de salsa</p>
                  </li>
                  <li>
                    <p>Maestro de fitness</p>
                  </li>
                  <li>
                    <p>Maestro de café</p>
                  </li>
                  <li>
                    <p>Maestro tequilero</p>
                  </li>
                </ul>
              </div> */}
              </div>
            </div>
            <div
              className={
                this.state.isFocused
                  ? "navbar-home__section navbar-home__sectionReduced navbar-home__actions"
                  : "navbar-home__section navbar-home__actions"
              }
            >
              <Select
                classNamePrefix="inputSelect"
                className="inputSelect"
                options={this.state.estados}
                value={this.state.estado}
                placeholder="Estado"
                onChange={this.setStateOnCookies}
                components={{ DropdownIndicator }}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 6,
                  colors: {
                    ...theme.colors,
                    primary50: "#ccc",
                    primary25: "#F6F6F6",
                    primary: "black",
                  },
                })}
                styles={{
                  dropdownIndicator: (provided, state) => ({
                    ...provided,
                    transform: state.selectProps.menuIsOpen && 'rotate(180deg)'
                  })
                }}
              />

              {user_token ?

                <Link>
                  {this.state.negocio.id ?
                    this.state.negocio.nuevo ?
                      <img className="settings-form__thumbNav" src={profileThumb} />
                      :
                      <div className={this.state.negocio.pro ? "settings-form__thumbNavPro" : null}>
                        <img className="settings-form__thumbNav" src={`${bucket_route}${this.state.negocio.imagen_url}`} alt="Perfil" onClick={() => { window.location.replace(`/${this.state.negocio.dominio_okki}`) }} />
                      </div>
                    :
                    <img className="settings-form__thumbNav" src={profileThumb} />
                  }
                </Link>

                :
                <Link className="button" to="/vender">
                  Vender
                </Link>
              }
            </div>
            <div className="navbar-iconWrapper">
              <a className="navbar-iconMenu" onClick={openNav}>
                <div></div>
                <div></div>
                <div></div>
              </a>
            </div>
          </header>
          <div className={this.state.activeMobileSearch ? "navbar-mobileSearch navbar-mobileSearch-show" : "navbar-mobileSearch"}>
            <div
              className={
                this.state.isFocusedMobile
                  ? "navbar-home__section navbar-mobileSearch__section "
                  : "navbar-home__section navbar-mobileSearch__section"
              }
            >
              <span
                className={
                  this.state.isFocusedMobile
                    ? "navbar-home__search-icon navbar-home__search-iconHover"
                    : "navbar-home__search-icon"
                }
                onClick={this.clearSearch}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="20" height="20" fill="white" />
                  <path d="M9.125 15.25C12.5077 15.25 15.25 12.5077 15.25 9.125C15.25 5.74226 12.5077 3 9.125 3C5.74226 3 3 5.74226 3 9.125C3 12.5077 5.74226 15.25 9.125 15.25Z" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M17 17L13.5 13.5" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

              </span>
                <input
                  type="search"
                  placeholder="Buscar..."
                  id="search"
                  ref={this.textInput}
                  style={{ backgroundImage: `url(${searchIcon})` }}
                  value={this.state.keywords}
                  onChange={(e)=>{this.handleSearch(e)}}
                  onKeyDown={handleKeyDown}
                  onKeyPress={handleKeyDown}
                  // onFocus={this.onFocusChangeMobile}
                  // onBlur={this.onFocusChangeMobile}
                  className="navbar-home__search"
                />
                <input type="submit" style={{ visibility: "hidden" }} />


            </div>
          </div>
          <div id="myNav" className="overlay" ref={this.setWrapperRef}>
            <a className="closebtn" onClick={closeNav}>

              <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" stroke="#111111" stroke-opacity="0.1" />
                <path d="M25.2427 16.7574L16.7574 25.2426" stroke="#111111" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M25.2426 25.2426L16.7573 16.7574" stroke="#111111" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>


            </a>
            {this.state.negocio.id ?
              <div
                id="overlayContent"
                className="overlay-contentAlt2"
                style={{ ...styleBuy, ...styleHire, ...styleEat }}
              >
                <div >
                  <Fade delay={500}>
                    <div id="menuContainer1">
                      <ul>
                        <li className="onlyMobile">
                          <Link>
                            <div className={this.state.negocio.pro ? "settings-form__thumbNavProResponsive" : null}>
                              <img className="settings-form__thumbNav" src={this.state.negocio ? `${bucket_route}${this.state.negocio.imagen_url}` : profileThumb} alt="Perfil" onClick={() => { window.location.replace(`/${this.state.negocio.dominio_okki}`) }} />
                            </div>
                            {/* <img className="settings-form__thumbNav" src={this.state.negocio.imagen_url ? `${route}/storage/${this.state.negocio.imagen_url}` : profileThumb} onClick={() => { window.location.replace(`/${this.state.negocio.dominio_okki}`) }} /> */}
                          </Link>
                        </li>
                        <li>
                          <Link to="/catalogo"
                            className="overlay-contentAlt2-buy"
                          >
                            Catálogo
       </Link>
                        </li>
                        <li>
                          <a
                            className="overlay-contentAlt2-eat"
                            onClick={() => this.openModal()}
                          >
                            Configuración
       </a>
                        </li>
                        {this.state.negocio.pro ?
                            <li className="overlay-contentAlt2-hire">
                              <Link to="/stats">
                                Estadísticas
                              </Link>
                            </li>
                          :
                          <li className="overlay-contentAlt2-pro">
                            <Link to={{
                                pathname: "/pro",
                              }}>
                              PRO
                          </Link>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.0222 7.82222L10 3L7.82222 7.82222L3 10L7.82222 12.0222L10 17L12.0222 12.0222L17 10L12.0222 7.82222Z" fill="#FF3C14" />
                            </svg>
                          </li>
                        }
                        <li>
                          <a
                            className="overlay-contentAlt2-hire"
                            onClick={logOut}
                          >
                            Salir
       </a>
                        </li>
                      </ul>
                    </div>

                  </Fade>
                </div>
                <div>
                  <Fade delay={500}>
                    <div id="menuContainer2">
                      <ul className="overlay-contentAlt2__menuMin">
                        <li className="overlay-contentAlt2-title">
                          <a className="overlay-contentAlt2-title" href="/comprar">
                            Comprar
       </a>
                        </li>
                        <li className="overlay-contentAlt2-title">
                          <a className="overlay-contentAlt2-title" href="/comer">
                            Comer
                 </a>
                        </li>
                        <li className="overlay-contentAlt2-title">
                          <a className="overlay-contentAlt2-title" href="/contratar">
                            Contratar
                 </a>
                        </li>
                      </ul>
                      <div className="onlyMobile">
                        <br />
                        <br />
                        <Select
                          classNamePrefix="inputSelect"
                          className="inputSelect"
                          options={this.state.estados}
                          value={this.state.estado}
                          placeholder="Estado"
                          onChange={this.setStateOnCookies}
                          components={{ DropdownIndicator }}
                          theme={(theme) => ({
                            ...theme,
                            borderRadius: 6,
                            colors: {
                              ...theme.colors,
                              primary50: "#ccc",
                              primary25: "#F6F6F6",
                              primary: "black",
                            },
                          })}
                          styles={{
                            dropdownIndicator: (provided, state) => ({
                              ...provided,
                              transform: state.selectProps.menuIsOpen && 'rotate(180deg)'
                            })
                          }}
                        />
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
              :
              <div
                id="overlayContent"
                className="overlay-content"
                style={{ ...styleBuy, ...styleHire, ...styleEat }}
              >
                <div>
                  <Fade delay={500}>
                    <div id="menuContainer1">
                      <ul>
                        <li>
                          <a
                            onMouseEnter={this.onMouseEnterBuy}
                            onMouseLeave={this.onMouseLeaveBuy}
                            id="buyBtn"
                            className="overlay-content-buy"
                            href="/comprar"
                          >
                            Comprar
                          </a>
                        </li>
                        <li>
                          <a
                            onMouseEnter={this.onMouseEnterEat}
                            onMouseLeave={this.onMouseLeaveEat}
                            className="overlay-content-eat"
                            href="/comer"
                          >
                            Comer
                          </a>
                        </li>
                        <li>
                          <a
                            onMouseEnter={this.onMouseEnterHire}
                            onMouseLeave={this.onMouseLeaveHire}
                            className="overlay-content-hire"
                            href="/contratar"
                          >
                            Contratar
                          </a>
                        </li>
                      </ul>
                    </div>
                  </Fade>
                </div>
                <div>
                  <Fade delay={500}>
                    <div id="menuContainer2">
                      <ul className="overlay-content__menuMin">
                        <li className="overlay-content-title">
                          <Link to="/vender" className="overlay-content-title">
                            Vender
                          </Link>
                        </li>
                        <li className="overlay-content-title">
                          <Link to="/nosotros" className="overlay-content-title">
                            Nosotros
                          </Link>
                        </li>
                        <li className="overlay-content-title">
                          <Link to="/login" className="enter overlay-content-title">
                            Iniciar sesión
                          </Link>
                        </li>
                      </ul>
                      <div className="onlyMobile">
                        <br />
                        <br />
                        <Select
                          classNamePrefix="inputSelect"
                          className="inputSelect"
                          options={this.state.estados}
                          value={this.state.estado}
                          placeholder="Estado"
                          onChange={this.setStateOnCookies}
                          components={{ DropdownIndicator }}
                          theme={(theme) => ({
                            ...theme,
                            borderRadius: 6,
                            colors: {
                              ...theme.colors,
                              primary50: "#ccc",
                              primary25: "#F6F6F6",
                              primary: "black",
                            },
                          })}
                          styles={{
                            dropdownIndicator: (provided, state) => ({
                              ...provided,
                              transform: state.selectProps.menuIsOpen && 'rotate(180deg)'
                            })
                          }}
                        />
                      </div>
                    </div>

                  </Fade>
                </div>
              </div>

            }

          </div>
          <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.state.negocio.nuevo ? false : this.closeModal}
            className="settingsModal"
            contentLabel="Example Modal"
          >
            <div className="settings-form settings-form__modal">
              <div className="settings-header settings-headerModal">
                <Link to="/" className="okkiLogoMobile">
                  <div>
                    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M40.5925 34.8254C41.9383 34.8927 43.0654 33.8161 43.0654 32.4703V30.1656C43.0654 29.8796 43.4019 29.7282 43.6206 29.9133L48.9869 34.3039C49.4243 34.6572 49.9458 34.8422 50.4841 34.8422C51.1738 34.8422 51.8467 34.5394 52.3009 33.9843C53.1252 32.975 52.9738 31.4946 51.9645 30.6703L47.4224 26.9525C47.086 26.6834 47.086 26.1787 47.4224 25.9095L51.9645 22.1918C52.9738 21.3675 53.1252 19.8871 52.3009 18.8778C51.4766 17.8684 49.9963 17.717 48.9869 18.5413L43.6206 22.932C43.4019 23.117 43.0654 22.9488 43.0654 22.6796V20.4254C43.0654 19.1637 42.0897 18.0703 40.828 18.003C39.4822 17.9357 38.3551 19.0123 38.3551 20.3581V32.403C38.3551 33.6647 39.3308 34.7581 40.5925 34.8254ZM31.4075 37.1806C30.0617 37.1133 28.9346 38.1899 28.9346 39.5357V41.8404C28.9346 42.1264 28.5981 42.2778 28.3794 42.0927L23.0131 37.7021C22.5757 37.3488 22.0542 37.1637 21.5159 37.1637C20.8262 37.1637 20.1533 37.4665 19.6991 38.0217C18.8748 39.031 19.0262 40.5114 20.0355 41.3357L24.5776 45.0535C24.914 45.3226 24.914 45.8273 24.5776 46.0964L20.0355 49.8142C19.0262 50.6385 18.8748 52.1189 19.6991 53.1282C20.5234 54.1376 22.0037 54.289 23.0131 53.4647L28.3794 49.074C28.5981 48.889 28.9346 49.0572 28.9346 49.3263V51.5637C28.9346 52.8254 29.9103 53.9189 31.172 53.9862C32.5178 54.0535 33.6449 52.9768 33.6449 51.631V39.5862C33.6449 38.3413 32.6692 37.2478 31.4075 37.1806ZM26.4112 18.003C21.7682 18.003 18 21.7712 18 26.4142C18 31.0572 21.7682 34.8254 26.4112 34.8254C31.0542 34.8254 34.8224 31.0572 34.8224 26.4142C34.8224 21.7712 31.0542 18.003 26.4112 18.003ZM26.4112 30.1151C24.3757 30.1151 22.7103 28.4497 22.7103 26.4142C22.7103 24.3787 24.3757 22.7133 26.4112 22.7133C28.4467 22.7133 30.1121 24.3787 30.1121 26.4142C30.1121 28.4497 28.4467 30.1151 26.4112 30.1151ZM51.6449 43.2366H39.5327C38.2374 43.2366 37.1776 44.2964 37.1776 45.5918C37.1776 46.8871 38.2374 47.9469 39.5327 47.9469H51.6449C52.9402 47.9469 54 46.8871 54 45.5918C54 44.2964 52.9402 43.2366 51.6449 43.2366Z" fill="black" />
                    </svg>

                  </div>
                </Link>
                <div className="navbar-iconWrapper-close">
                  <svg onClick={this.closeModal} width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" stroke="#EEEEEE" />
                    <path d="M25.2422 16.7573L16.7569 25.2426" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M25.2431 25.2426L16.7578 16.7573" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </div>
              </div>
              <div className="row">
                <div
                  className={this.state.negocio.nuevo ? "disabledDiv" : ""}
                >
                  <div className="four columns settings-form__sidebar">

                    <div className="settings-header settings-headerModal">
                      <div className="settings-header__breadcrumb settings-header__breadcrumb-title">
                        <h3 className="settings-header__title">Configuración</h3>
                        <select onChange={(e) => { this.setState({ settings_section: e.target.value }) }} className="settings-form__menuSelect inputSelect" style={{ backgroundImage: `url(${selectIcon})` }}>
                          <option value="0">Perfil</option>
                          <option value="1">Negocio</option>
                          <option value="2">Dirección y Envíos</option>
                          <option value="3">Redes Sociales</option>
                          <option value="4">Cuenta</option>
                          <option value="5" >Plan</option>
                        </select>
                        <hr className="settingsDivider" />
                      </div>
                    </div>
                    <ul className="settings-form__menu settings-form__menuList" className={this.state.negocio.nuevo ? "displayNone" : "settings-form__menu settings-form__menuList"}>
                      <li>
                        <Link onClick={() => { this.setState({ settings_section: 0 }) }} className={this.state.settings_section == 0 ? "active" : ""}>
                          Perfil
                        </Link>
                      </li>
                      <li>
                        <Link onClick={() => { this.setState({ settings_section: 1 }) }} className={this.state.settings_section == 1 ? "active" : ""}>
                          Negocio
                        </Link>
                      </li>
                      <li>
                        <Link onClick={() => { this.setState({ settings_section: 2 }) }} className={this.state.settings_section == 2 ? "active" : ""}>
                          Dirección y Envíos
                        </Link>
                      </li>
                      <li>
                        <Link onClick={() => { this.setState({ settings_section: 3 }) }} className={this.state.settings_section == 3 ? "active" : ""}>
                          Redes Sociales
                        </Link>
                      </li>
                      <li>
                        <Link onClick={() => { this.setState({ settings_section: 4 }) }} className={this.state.settings_section == 4 ? "active" : ""}>
                          Cuenta
                        </Link>
                      </li>
                      <li>
                        <Link onClick={() => { this.setState({ settings_section: 5 }) }} className={this.state.settings_section == 5 ? "active" : ""}>
                          Plan
                        </Link>
                      </li>

                    </ul>

                  </div>
                </div>
                {this.state.settings_section == 0 ?
                  <Settings />
                  :
                  this.state.settings_section == 1 ?
                    <SettingsNegocio />
                    :
                    this.state.settings_section == 2 ?
                      <Settings2 />
                      :
                      this.state.settings_section == 3 ?
                        <Settings3 />
                        :
                        this.state.settings_section == 4 ?
                          <Settings4 />
                          :
                          <Settings5 />
                }
              </div>
            </div>
          </Modal>

          <Modal
            isOpen={this.state.modalWelcomeIsOpen}
            onRequestClose={this.state.negocio.nuevo ? false : this.closeWelcomeModal}
            className="settingsModal"
            contentLabel="Example Modal"
          >

            <WelcomeSettings />
            <div className="settings-form__rowLast settings-form__rowLast-modalWelcome">
              <a className="button" onClick={() => { this.closeWelcomeModal() }}>
                Configura tu negocio
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 14L15 10L11 6" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15 10L5 10" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

              </a>
            </div>

          </Modal>
        </div>
      </>

    );
  }
}
